import CheckIcon from '@mui/icons-material/Check';
import ClearIcon from '@mui/icons-material/Clear';
import { Box, Chip, Grid, Stack, Tooltip, Typography } from '@mui/material';
import MUIDataTable from 'mui-datatables';
import * as React from 'react';
import * as Redux from 'react-redux';
import styled from 'styled-components';
import * as CONST from '../../../constants/FieldsConst';
import { textLabels } from '../../../helpers';
import { useNotification } from '../../../helpers/Notification';
import { LoadingWidget } from '../../../widgets';
import ActionsListWidget from '../../../widgets/ActionsList';
import DeleteModalComponent from '../../../widgets/modals/DeleteModal';
import { NameComponent } from '../../usuario/usuarios/components/ListadoUsuarios';
import {
  allPermisosAction,
  deletePermisosAction,
  setActivoPermisosAction,
} from '../PermisosAction';
import { PARAMS_PERMISOS } from '../PermisosReducer';

export const Links = styled.a`
  cursor: pointer;
  color: black;
  margin: 0px 0px;
  text-decoration: none;

  &:hover {
    color: blue;
  }
`;

const ListadoPermisos = ({ setOpenModalForm }) => {
  const dispatch = Redux.useDispatch();
  const { notify } = useNotification();

  const loginStore = Redux.useSelector((state) => state.login);
  const permisosStore = Redux.useSelector((state) => state.permisos);
  const usuEntPerfilesStore = Redux.useSelector(
    (state) => state.usuEntPerfiles,
  );

  const [loadingDelete, setLoadingDelete] = React.useState(false);
  const [openModalDelete, setOpenModalDelete] = React.useState(false);
  const [rows, setRows] = React.useState([]);

  React.useEffect(() => {
    const fetchData = async () => {
      const payload = {
        ...permisosStore.params,
        idUsuEntPerfil: usuEntPerfilesStore.activo.id,
      };
      dispatch({ type: PARAMS_PERMISOS, payload });
      allPermisosAction({ dispatch }, payload);
    };
    return fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    setRows([]);
    const d = [];
    permisosStore.all.map((el) =>
      d.push({
        ...el,
        inicio: el.isInicio,
        nombre: el.vista.vista.nombre,
        estatus: el.estatus,
      }),
    );
    setRows(d);
  }, [permisosStore.all]);

  const _handleEditClick = async (id) => {
    const data = permisosStore.all.find((el) => el.id === id);
    await setActivoPermisosAction(dispatch, data);
    setOpenModalForm(true);
  };

  const _onDeleteHandler = async () => {
    setLoadingDelete(true);
    await deletePermisosAction(
      { dispatch, notify },
      permisosStore.activo.id,
      permisosStore.params,
    );
    setLoadingDelete(false);
    setOpenModalDelete(false);
  };

  function getIcon(value) {
    return value ? <CheckIcon color="success" /> : <ClearIcon color="error" />;
  }

  const columns = [
    {
      name: CONST.ID,
      options: {
        display: loginStore.isRoot ? false : 'excluded',
        filter: false,
      },
    },
    {
      name: CONST.nombre.name,
      label: CONST.nombre.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <NameComponent
              onClick={() => _handleEditClick(tableMeta.rowData[0])}
            >
              {value}
            </NameComponent>
          );
        },
      },
    },
    {
      name: CONST.inicio.name,
      label: 'Inicio App',
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => getIcon(value),
      },
    },
    {
      name: CONST.create.name,
      label: CONST.create.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => getIcon(value),
      },
    },
    {
      name: CONST.read.name,
      label: CONST.read.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => getIcon(value),
      },
    },
    {
      name: CONST.update.name,
      label: CONST.update.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => getIcon(value),
      },
    },
    {
      name: CONST.deleted.name,
      label: CONST.deleted.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => getIcon(value),
      },
    },
    {
      name: CONST.report.name,
      label: CONST.report.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => getIcon(value),
      },
    },

    {
      name: CONST.estatus.name,
      label: CONST.estatus.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Box sx={{ width: '70px' }}>
              <Tooltip
                describeChild
                title="Estatus del registro"
                placement="left"
              >
                <Chip
                  label={value.nombre}
                  size="small"
                  color={value.id === 1 ? 'success' : 'error'}
                />
              </Tooltip>
            </Box>
          );
        },
      },
    },
    {
      name: CONST.actions.name,
      label: CONST.actions.label,
      options: {
        filter: false,
        sort: false,
        empty: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Box sx={{ width: '70px' }}>
              <Stack direction="row">
                <ActionsListWidget
                  id={tableMeta.rowData[0]}
                  onEdit={() => _handleEditClick(tableMeta.rowData[0])}
                  onDelete={async () => {
                    const data = permisosStore.all.find(
                      (el) => el.id === tableMeta.rowData[0],
                    );
                    await setActivoPermisosAction(dispatch, data);
                    setOpenModalDelete(true);
                  }}
                />
              </Stack>
            </Box>
          );
        },
      },
    },
  ];

  const options = {
    filterType: 'dropdown',
    setTableProps: () => {
      return {
        padding: 'none',
        size: 'small',
      };
    },
    rowsPerPage: 25,
    rowsPerPageOptions: [25, 50, 100],
    print: false,
    textLabels,
    selectableRowsHideCheckboxes: true,
    expandableRows: true,
    renderExpandableRow: (rowData, rowMeta) => {
      return <Grid container></Grid>;
    },
  };

  return (
    <Grid container>
      <Grid item md={12}>
        <LoadingWidget isLoading={permisosStore.loadingAll || loadingDelete} />
        <MUIDataTable
          title={'Listado'}
          data={rows}
          columns={columns}
          options={options}
        />
      </Grid>
      {permisosStore.activo && (
        <DeleteModalComponent
          open={openModalDelete}
          onClose={() => setOpenModalDelete(!openModalDelete)}
          onDelete={_onDeleteHandler}
        >
          <Typography variant="h6">{permisosStore.activo.nombre}</Typography>
        </DeleteModalComponent>
      )}
    </Grid>
  );
};

export default ListadoPermisos;
